import { FreeTierOverlay } from '@/components/app-overlay/FreeTierOverlay.jsx'
import { useCurrentAccount } from '@/hooks/useCurrentAccount.jsx'
import { usePaymentContext } from '@/context-state/PaymentContext'

// Self-serve Free is a real, usable tier gated per-surface (see the client
// entitlements layer + freeTierEntitlements.js), so it is NOT walled here.
//
// This guard walls two cases:
// 1. An account with a pending CUSTOM CHECKOUT (account.customCheckout holds a
//    Paddle transaction id). It is walled regardless of tier/trial until it pays;
//    the overlay's PricingPlans auto-opens that transaction. The backend clears
//    customCheckout once the subscription is created, which lifts the wall.
// 2. A HIGH-TOUCH MANUAL TRIAL that has EXPIRED. Those accounts got generous
//    (near-unlimited) access for X days via a trialDates window; once it lapses
//    their access is denied until they upgrade. They are distinguishable from
//    self-serve Free by carrying a past `trialEndsAt` (self-serve Free has none).
// Active trials and paid tiers otherwise pass straight through.
export const FreeTierLockGuard = ({ children }) => {

    const { account } = useCurrentAccount()
    const { entitlements } = usePaymentContext()

    const hasPendingCustomCheckout = !!account?.customCheckout

    const tier = entitlements?.tier ?? 0
    const isPaid = tier > 0
    const activeTrial = entitlements?.activeTrial
    const trialEndsAt = entitlements?.trialEndsAt
    const trialExpired = !!trialEndsAt && new Date(trialEndsAt) < new Date()

    // Deny an expired manual trial: not paying, not currently on trial, but it
    // did have a trial window that has now passed.
    const isExpiredTrial = !isPaid && !activeTrial && trialExpired

    return (
        hasPendingCustomCheckout || isExpiredTrial ? <FreeTierOverlay /> : children
    )
}
